import React from 'react';
import { Impact, IMPACT_FA } from '@/utils/calendar/calendarFormat';

const FILLED: Record<Impact, number> = { low: 1, medium: 2, high: 3 };
const TONE: Record<Impact, string> = {
    high: 'bg-error dark:bg-customError',
    medium: 'bg-amber-500',
    low: 'bg-gray-400 dark:bg-gray-500',
};

/** Importance as three dots (count, not only colour) with a text label for screen readers. */
const ImpactDots: React.FC<{ impact: Impact }> = ({ impact }) => (
    <span
        role='img'
        aria-label={`اهمیت ${IMPACT_FA[impact]}`}
        title={`اهمیت ${IMPACT_FA[impact]}`}
        className='inline-flex items-center gap-0.5'
    >
        {[0, 1, 2].map((i) => (
            <span
                key={i}
                className={`size-1.5 rounded-full ${i < FILLED[impact] ? TONE[impact] : 'bg-gray-200 dark:bg-white/15'}`}
            />
        ))}
    </span>
);

export default ImpactDots;
